/* eslint-disable react-hooks/exhaustive-deps */
import Footer from '../../components/Footer/Footer';
import { useLocation } from 'react-router-dom';
import { Header } from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import searchIcon from '../../assets/assets/search.svg';
import closeIcon from '../../assets/assets/close.svg';
import { DetalhamentoNegocio } from '../../components/Detalhamento';
import { Container, Content } from './styles';
import { MdPieChart } from 'react-icons/md';
import { useHeaderFilter } from '../../hooks/hooks/useHeaderFilter';
import { FiltrosDiv, Selects } from '../../components/components/Header/styles';
import { useDashboard } from '../../context/context/DashboardContext';
import { useEffect, useState } from 'react';
import { useNegocioContext } from '../../context/context/DetalhamentoNegocioContext';
import { useLoading } from '../../hooks/useLoading';
import { useUser } from '../../hooks/useUser';
import { Loader } from '../../components/Loader/Loader';
import { SelectAccount } from '../../components/Select/SelectAccount';
import arrowGray from '../../assets/assets/arrow_gray.svg';

function Detailing() {
  const [account, setAccount] = useState('Principal');
  const [portal, setPortal] = useState('Todos');
  const {
    setDataFimHeader,
    setDataInicioHeader,
    dataFim,
    dataInicio,
    filtroDataCredorDashboard,
    setFiltro,
    filtrado,
    chamado,
  } = useHeaderFilter();
  const { setHistorico } = useDashboard();
  const location = useLocation();

  async function handleSubmit() {
    showLoader();
    const current_credor = JSON.parse(localStorage.getItem('currentCompany')!);
    let id_app_acesso: number | undefined = undefined;
    if (portal === 'Whatsapp') {
      id_app_acesso = 2;
    } else if (portal === 'Portal') {
      id_app_acesso = 1;
    }
    getNegocio(
      dataInicio,
      dataFim,
      account === 'Principal'
        ? current_credor.credor_infos.credor_crm
        : current_credor.credor_infos.conta_parcelamento,
      id_app_acesso,
    );
    hideLoader();
    // setFiltro(true);
    // const isBeforeDate = isBefore(new Date(dataInicio), new Date(dataFim));
    // if (isBeforeDate || dataInicio === dataFim) {
    //   let isCancelar = false;
    //   setHistorico('Histórico', 'brown');

    //   // await filtroDataCredorDashboard(isCancelar, location.pathname);
    // }
  }

  async function cancelaFiltro() {
    setFiltro(false);
    let isCancelar = true;
    setHistorico('Real Time', 'green');
    // onOptionSelected('Todos', true);
    await filtroDataCredorDashboard(isCancelar, location.pathname);
  }
  // const isProcessamento = false;
  const { negocio, getNegocio } = useNegocioContext();
  const { currentCompany } = useUser();
  const { showLoader, hideLoader, loader } = useLoading();
  useEffect(() => {
    showLoader();
    const current_credor = JSON.parse(localStorage.getItem('currentCompany')!);
    let id_app_acesso: number | undefined = undefined;
    if (portal === 'Whatsapp') {
      id_app_acesso = 2;
    } else if (portal === 'Portal') {
      id_app_acesso = 1;
    }
    getNegocio(
      dataInicio,
      dataFim,
      account === 'Principal'
        ? current_credor.credor_infos.credor_crm
        : current_credor.credor_infos.conta_parcelamento,
      id_app_acesso,
    );
    // getNegocio(dataInicio, dataFim, selectedCredorOption);
    hideLoader();
  }, [currentCompany]);

  useEffect(() => {
    showLoader();
  }, [filtrado, chamado]);

  useEffect(() => {
    hideLoader();
  }, [negocio]);

  return (
    <Container>
      {loader && <Loader />}
      <Sidebar />
      <Header
        icon={<MdPieChart color="#A6A6A6" size="32px" />}
        title="Detalhamento"
      >
        <div
          style={{
            height: '70px',
            width: '100%',
            borderBottom: '1px solid var(--color-primary)',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '2rem',
            fontSize: '8px',
            fontWeight: 300,
          }}
        >
          <Selects>
            <FiltrosDiv>
              <p>Inicio: </p>
              <input
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicioHeader(e.target.value)}
                max={dataFim}
              />
              <p>Final: </p>
              <input
                type="date"
                value={dataFim}
                onChange={(e) => setDataFimHeader(e.target.value)}
                min={dataInicio}
              />
              <p style={{ marginRight: '1rem' }}>Conta: </p>
              <SelectAccount
                setAccount={setAccount}
                account={account}
                options={['Principal', 'Parcelamento']}
                nameSelect="Selecione"
                icon={arrowGray}
              />
              <p style={{ marginRight: '1rem', marginLeft: '1rem' }}>Canal: </p>
              <SelectAccount
                setAccount={setPortal}
                account={portal}
                options={['Portal', 'Whatsapp', 'Todos']}
                nameSelect="Selecione"
                icon={arrowGray}
              />
              <button onClick={handleSubmit}>
                <img src={searchIcon} alt="Filtrar" />
              </button>

              {filtrado && (
                <button onClick={cancelaFiltro}>
                  <img src={closeIcon} alt="Cancelar filtro" />
                </button>
              )}
            </FiltrosDiv>
          </Selects>
        </div>
      </Header>
      <Content>
        <DetalhamentoNegocio account={account} appAcesso={portal} />
      </Content>
      <Footer />
    </Container>
  );
}

export default Detailing;
